import React from 'react'
import { Link } from 'react-router-dom'
import logowhite from "../images/logowhite.png";

const Footer: React.FC = () => {
    return (
        <footer className="bg-dark text-white border-t">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">

                    <div>
                        <img src={logowhite} alt="Guardrisk Logo" className="h-20 w-auto mb-4" />
                        <p className="text-gray-400 text-sm">
                            Leading insurance brokers providing comprehensive coverage solutions.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-display font-semibold mb-4">Navigation</h4>
                        <ul className="space-y-2 text-sm text-gray-400">
                            <li><Link to="/" className="hover:text-white transition">Home</Link></li>
                            <li><Link to="/about" className="hover:text-white transition">About Us</Link></li>
                            <li><Link to="/services" className="hover:text-white transition">Services</Link></li>
                            <li><Link to="/blog" className="hover:text-white transition">Blog</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-display font-semibold mb-4">Contact</h4>
                        <ul className="space-y-2 text-sm text-gray-400">
                            <li>Phone: +233 (24) 287-6315</li>
                            <li>Email: hakoomson@guardrisk.org</li>
                            <li>Address: Nmai-Dzorm, Adjiringano Street, Accra Opposite Ability Square.
                                GPS: GD-166-726 </li>

                        </ul>
                    </div>

                    <div>
                        <h4 className="font-display font-semibold mb-4">Follow Us</h4>
                        <div className="flex gap-4">
                            <button className="text-gray-400 hover:text-brand transition" aria-label="Facebook">
                                <span className="icon icon-[mdi--facebook]" style={{ fontSize: '20px' }}></span>
                            </button>
                            <button className="text-gray-400 hover:text-brand transition" aria-label="Twitter">
                                <span className="icon icon-[mdi--twitter]" style={{ fontSize: '20px' }}></span>
                            </button>
                            <button className="text-gray-400 hover:text-brand transition" aria-label="LinkedIn">
                                <span className="icon icon-[mdi--linkedin]" style={{ fontSize: '20px' }}></span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="border-t border-gray-700 pt-8 flex justify-between items-center text-sm text-gray-400">
                    <p>&copy; 2026 Guardrisk Limited. All rights reserved.</p>
                    <div className="flex gap-4">
                        <button className="hover:text-white transition">Privacy Policy</button>
                        <button className="hover:text-white transition">Terms of Service</button>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
